// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-layout-GridLayoutAdditionalHeader-GridLayoutAdditionalHeader-module__container-CooTpF"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-layout-GridLayoutAdditionalHeader-GridLayoutAdditionalHeader-module__container-CooTpF\"}";
        // 1789362522802
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  